import { render, staticRenderFns } from "./a1.vue?vue&type=template&id=00d4fb0e&scoped=true&"
import script from "./a1.vue?vue&type=script&lang=js&"
export * from "./a1.vue?vue&type=script&lang=js&"
import style0 from "./a1.vue?vue&type=style&index=0&id=00d4fb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d4fb0e",
  null
  
)

export default component.exports